import { token } from '@atlaskit/tokens';
import { cssMap } from '@atlaskit/css';

const AVATAR_URL =
  'https://cdn.jim-nielsen.com/ios/512/facebook-2019-05-21.png?rf=1024';

const styles = cssMap({
  image: {
    borderRadius: token('radius.xsmall', '2px'),
    width: '48px',
  },
});

const Logo = () => <img src={AVATAR_URL} css={styles.image} />;

export default Logo;
